export default "__VITE_ASSET__DAW_ES2n__"